import type ConversationItem from 'mini-mail-list-store/lib/store/schema/ConversationItem';
import getTableConversationRelation from 'mini-mail-list-store/lib/utils/getTableConversationRelation';
import { getIsPinned } from 'mini-mail-list-store/lib/selectors/mailListDataPropertyGetter';
import { getIsUnflagged, getIsUnread } from 'mini-mail-list-store/lib/utils/getTriageState';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import type { MailListItemViewProps } from '../../components/TouchBehavior';
import {
    lazyApplyConversationFlaggedState,
    lazyArchiveRow,
    lazyDeleteConversation,
    lazyMarkConversationAsRead,
    lazyPinConversation,
} from 'mini-mail-triage-actions';
import { type TriageActionSource } from 'mini-mail-triage-actions/lib/schema/TriageActionSource';

export const deleteConversationAction = (props: MailListItemViewProps) => {
    const { rowId } = props.mailListItemDataProps;
    const conversationItem: ConversationItem = getListViewStore().conversationItems.get(rowId);
    const noOfItemsInConversation = conversationItem.globalItemIds
        ? conversationItem.globalItemIds.length
        : 0;
    lazyDeleteConversation({
        conversationId: conversationItem.id,
        originalTableViewId: props.tableViewId,
        noOfItemsInConversation,
        sourceView: 'ListView',
    });
};

export const archiveConversationAction = (props: MailListItemViewProps) => {
    const { rowId } = props.mailListItemDataProps;
    lazyArchiveRow(rowId, props.tableViewId);
};

export const toggleConversationReadAction = (props: MailListItemViewProps) => {
    const { rowId } = props.mailListItemDataProps;
    const tableViewId = props.tableViewId;
    lazyMarkConversationAsRead(rowId, getIsUnread(rowId) /* shouldMarkAsRead */, tableViewId);
};

export const toggleConversationFlagAction = (props: MailListItemViewProps) => {
    const { rowId } = props.mailListItemDataProps;
    const tableViewId = props.tableViewId;
    lazyApplyConversationFlaggedState(
        rowId,
        getIsUnflagged(rowId) /* shouldMarkAsFlagged */,
        tableViewId
    );
};

export const toggleConversationPinAction = (props: MailListItemViewProps) => {
    const { rowId } = props.mailListItemDataProps;
    const tableViewId = props.tableViewId;
    const tableView = getListViewStore().tableViews.get(tableViewId);
    const tableConversationRelation = getTableConversationRelation(rowId, tableViewId);

    lazyPinConversation(
        rowId,
        tableConversationRelation.itemIds,
        tableViewId,
        !getIsPinned(rowId, tableView) /* shouldMarkAsPinned */
    );
};
